import { render } from "./OurStory.vue?vue&type=template&id=21baa272&scoped=true"
import script from "./OurStory.vue?vue&type=script&lang=js"
export * from "./OurStory.vue?vue&type=script&lang=js"

import "./OurStory.vue?vue&type=style&index=0&id=21baa272&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21baa272"]])

export default __exports__